import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Page from "../../components/Page";
import { ATTICUS_PAGE_PREFIX, SCREEN_PATHS } from "../../constants";
import { Link, useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

export const EmailVerificationRequired = (): JSX.Element => {
  console.log("user reached email verification required screen");

  const { user } = useAuth0()

  return (
    <Page
      sx={{
        backgroundColor: "background.default",
        height: "100%",
        py: 3,
      }}
      title={`${ATTICUS_PAGE_PREFIX} - Email Verification Required`}
    >
      
      <Box
        display="flex"
        flexDirection="column"
        height="40%"
        justifyContent="center"
      >
        <Container maxWidth="md">
          <Box display="flex" flexDirection="column" alignItems="center" gap="1rem">
            <Typography variant="h3" gutterBottom>
              Welcome to Atticus!
            </Typography>
            <Typography
              sx={{
                mb: 2,
                textAlign: "center",
              }}
            >
               Please check your email and verify your email address, and then <Link to={SCREEN_PATHS.signOut}>login</Link>.   
              <br /><br />
              If you need to resend the verification email, please email us at <a href="mailto:support@weareatticus.biz">support@weareatticus.biz</a>.
            </Typography>
              
          </Box>
        </Container>
      </Box>
    </Page>
  );
};
